module.exports = __webpack_public_path__ + "705682eab0e13cb67f3246f438c9b872.pdf";